import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Helmet } from 'react-helmet';

export default function Auth() {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Show loading for 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
      
      // Load Klaviyo script after initial loading completes
      loadKlaviyoScript();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {

  }, []);

  const loadKlaviyoScript = () => {
    // Check if script is already loaded
    if (document.querySelector('script[src*="klaviyo.com"]')) return;
    
    // Load the main Klaviyo script
    const mainScript = document.createElement('script');
    mainScript.async = true;
    mainScript.type = 'text/javascript';
    mainScript.src = 'https://static.klaviyo.com/onsite/js/VPUF5a/klaviyo.js?company_id=VPUF5a';
    document.body.appendChild(mainScript);

    // Load the initialization script
    const initScript = document.createElement('script');
    initScript.type = 'text/javascript';
    initScript.text = `
      !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
    `;
    document.body.appendChild(initScript);

    // Load the form script
    const formScript = document.createElement('script');
    formScript.src = '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
    formScript.async = true;
    formScript.onload = () => {
      // Initialize Klaviyo form after script loads
      if (window.KlaviyoSubscribe) {
        window.KlaviyoSubscribe.attachToForms('#klaviyo-form', {
          success_message: "Thank you! You've been added to our list.",
          custom_success_message: true
        });
      }
    };
    document.body.appendChild(formScript);
  };

  const handleClose = () => {
    if (window.opener) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#000000',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px',
      boxSizing: 'border-box'
    }}>
      <Helmet>
        <title>Early Access | Outlne</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {isLoading ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '3px solid #333',
            borderTop: '3px solid #fff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <div style={{
            color: 'white',
            fontFamily: 'avenir-lt-pro, sans-serif',
            fontSize: '1rem'
          }}>
            Loading...
          </div>
        </div>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          maxWidth: '270px',
          gap: '30px'
        }}>
          <div style={{
            color: 'white',
            fontFamily: 'avenir-lt-pro, sans-serif',
            fontSize: '1.5rem',
            fontWeight: '500',
            lineHeight: '1.4'
          }}>
            Access is currently<br></br> by invitation only.
          </div>
          
          <div style={{
            color: '#ccc',
            fontFamily: 'avenir-lt-pro, sans-serif',
            fontSize: '1.1rem',
            fontStyle: 'italic',
            lineHeight: '1.5'
          }}>
            Get on the list and be among the first to experience a new era of modern interior designing.
          </div>

          <div style={{
            width: '100%',
            padding: '20px',
            backgroundColor: '#1a1a1a',
            borderRadius: '10px',
            border: '1px solid #333'
          }}>
            <div id="klaviyo-form" className="klaviyo-form-QVA4KX"></div>
          </div>

          <button 
            onClick={handleClose}
            style={{
              backgroundColor: 'white',
              color: '#000',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontFamily: 'avenir-lt-pro, sans-serif',
              fontSize: '1rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#f0f0f0'}
            onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
          >
            {window.opener ? 'Close Window' : 'Return to Home'}
          </button>
        </div>
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}